import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { VirtualBrand } from '~/Api/Analytics/VirtualBrand';
import { selectDataSourcesByCountry, State as DataSourceState } from '~/MedicinalBrandsAnalytics/DataSource';
import {
	RegionAvailability,
	selectRegionAvailabilities,
	State as RegionState,
} from '~/MedicinalBrandsAnalytics/Region';
import {
	loadReimbursement,
	Reimbursement,
	selectReimbursementById,
	State as ReimbursementState,
} from '~/MedicinalBrandsAnalytics/VirtualBrand/Reimbursement';

import ReimbursementTab from './ReimbursementTab';

interface State {
	medicinalBrandsAnalyticsRegion: RegionState;
	medicinalBrandsAnalyticsDataSource: DataSourceState;
	medicinalBrandsAnalyticsReimbursement: ReimbursementState;
}

interface OwnProps {
	virtualBrand: VirtualBrand;
}

const memoizedSelectDefaultRegionAvailability = memoizeOne(
	(regionState: RegionState, dataSourceState: DataSourceState): RegionAvailability | null => {
		const availabilities = selectRegionAvailabilities(
			regionState,
			selectDataSourcesByCountry(dataSourceState.dataSources || [])
		);
		return availabilities?.find((regionAvailability) => regionAvailability.region.id === 'europe') || null;
	}
);

function mapStateToProps(
	{ medicinalBrandsAnalyticsRegion, medicinalBrandsAnalyticsDataSource, medicinalBrandsAnalyticsReimbursement }: State,
	{ virtualBrand }: OwnProps
): {
	isFetching: boolean;
	reimbursements: Reimbursement[] | null;
	defaultRegionAvailability: RegionAvailability | null;
} {
	const reimbursementState = selectReimbursementById(medicinalBrandsAnalyticsReimbursement, virtualBrand.id);

	return {
		isFetching: reimbursementState?.isFething || false,
		reimbursements: reimbursementState?.items || null,
		defaultRegionAvailability: memoizedSelectDefaultRegionAvailability(
			medicinalBrandsAnalyticsRegion,
			medicinalBrandsAnalyticsDataSource
		),
	};
}

const actions = {
	onLoad: loadReimbursement,
};

export default connect(mapStateToProps, actions)(ReimbursementTab);
